import {
  VIBE_CODING_GET_CONVERSATION_HISTORY_BEGIN,
  VIBE_CODING_GET_CONVERSATION_HISTORY_SUCCESS,
  VIBE_CODING_GET_CONVERSATION_HISTORY_FAILURE,
  VIBE_CODING_GET_CONVERSATION_HISTORY_DISMISS_ERROR,
} from './constants';
import { fetchConversationHistory } from '../services/vibeCodingService';
import {
  createRequestId,
  matchesRequest,
} from '../../../features-v2/vibe-coding/utils/requestUtils';
import { mergeUniqueMessages } from '../../../features-v2/vibe-coding/utils/messageUtils';

const createHistoryRequestId = () => createRequestId('vibe-history');

const matchesHistoryRequest = (state, meta = {}) =>
  matchesRequest(state.activeHistoryRequestId, meta.requestId);

export function getConversationHistory(args = {}) {
  return async (dispatch) => {
    const requestId = createHistoryRequestId();
    dispatch({
      type: VIBE_CODING_GET_CONVERSATION_HISTORY_BEGIN,
      meta: { requestId, conversationId: args.conversationId, append: Boolean(args.append) },
    });

    try {
      const data = await fetchConversationHistory(args);
      dispatch({
        type: VIBE_CODING_GET_CONVERSATION_HISTORY_SUCCESS,
        data: {
          conversationId: args.conversationId,
          messages: Array.isArray(data) ? data : data && data.messages,
          hasMore: Array.isArray(data) ? false : Boolean(data && data.hasMore),
          nextBefore: Array.isArray(data) ? null : data && data.nextBefore,
          append: Boolean(args.append),
        },
        meta: { requestId, append: Boolean(args.append) },
      });
      return data;
    } catch (err) {
      dispatch({
        type: VIBE_CODING_GET_CONVERSATION_HISTORY_FAILURE,
        data: { error: err },
        meta: { requestId, append: Boolean(args.append) },
      });
      throw err;
    }
  };
}

export function dismissGetConversationHistoryError() {
  return { type: VIBE_CODING_GET_CONVERSATION_HISTORY_DISMISS_ERROR };
}

export function reducer(state, action) {
  const meta = action.meta || {};
  switch (action.type) {
    case VIBE_CODING_GET_CONVERSATION_HISTORY_BEGIN:
      return {
        ...state,
        getConversationHistoryPending: !action.meta.append,
        getConversationHistoryMorePending: Boolean(action.meta.append),
        getConversationHistoryError: null,
        activeHistoryRequestId: meta.requestId || state.activeHistoryRequestId,
      };
    case VIBE_CODING_GET_CONVERSATION_HISTORY_SUCCESS: {
      if (!matchesHistoryRequest(state, meta)) return state;
      const formattedMessages = Array.isArray(action.data.messages)
        ? action.data.messages
            .slice()
            .reverse()
            .map((m) => ({
              ...m,
              id: m.id || m.uuid,
            }))
        : [];
      const messages = action.data.append
        ? mergeUniqueMessages(formattedMessages, state.messages)
        : mergeUniqueMessages(formattedMessages);
      return {
        ...state,
        getConversationHistoryPending: false,
        getConversationHistoryMorePending: false,
        getConversationHistoryError: null,
        conversationId: action.data.conversationId,
        messages,
        conversationHistoryHasMore: Boolean(action.data.hasMore),
        conversationHistoryBefore: action.data.nextBefore || null,
      };
    }
    case VIBE_CODING_GET_CONVERSATION_HISTORY_FAILURE:
      if (!matchesHistoryRequest(state, meta)) return state;
      return {
        ...state,
        getConversationHistoryPending: false,
        getConversationHistoryMorePending: false,
        getConversationHistoryError: action.data.error,
      };
    case VIBE_CODING_GET_CONVERSATION_HISTORY_DISMISS_ERROR:
      return {
        ...state,
        getConversationHistoryError: null,
      };
    default:
      return state;
  }
}
